import React, { useState } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, TextField, DialogActions, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import axios from 'axios';
import { useHistory } from 'react-router-dom'; 

function Page2SubPageC() {
  const history = useHistory(); 
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [type, setType] = useState('');
  const [content, setContent] = useState('');
  const [electionCategory, setElectionCategory] = useState('');
  const handleChange = (event) => setElectionCategory(event.target.value);

  const handleSubmit = async () => {
    try {
      await axios.post('/api/govCandidacy', {
        name,
        electionCategory,
        type,
        content,
        topic: 'page2c5subpaged' 
      });
      setOpen(false);
      setName('');
      setElectionCategory('');
      setType('');
      setContent('');
      alert('Post created!');
    } catch (err) {
      console.error('Failed to create post', err);
    }
  };

  return (
    <div
           style={{
               padding: '20px',
               backgroundColor: '#FFFDF8',
               minHeight: '100vh',  // ensures it covers the full viewport height
               boxSizing: 'border-box', // ensures padding doesn't affect layout
           }}
       >


           <div style={{ width: '200px' }}></div>


           {/* Centered Buttons */}
           <Box
               display="flex"
               justifyContent="center"
               alignItems="center"
               gap={2}
               flexWrap="wrap"
               sx={{
                   mt: 4,
                   mb: 4,
               }}
                   >
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                      onClick={() => history.push('/Government/Elections/USHouseOfRepresentativesElections')}
                   >
                       U.S. House of Representatives
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/Government/Elections/USSenateElections')}
                   >
                       U.S. Senate
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/Government/Elections/GubernatorialElections')}
                   >
                       State Governors
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/Government/Elections/StateLegislatureElections')}
                   >
                       State Legislatures
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/Government/Elections/StatewideOfficesElections')}
                   >
                       Statewide Offices
                   </Button>
                  
              </Box>
        </div>
    /*
    <Box p={4}>
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button variant="contained" onClick={() => history.push('/page2/c1')}>
          Popular votes by the moral-intelligentsia
        </Button>
        <Button variant="contained" onClick={() => history.push('/page2/c2')}>
          Federal
        </Button>
        <Button variant="contained" onClick={() => history.push('/page2/c3')}>
          State
        </Button>
        <Button variant="contained" onClick={() => history.push('/page2/c4')}>
          Local
        </Button>

        <Button variant="contained" onClick={() => setOpen(true)}>
          Candidacy
        </Button>
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Endorse a Candidate or Run for Candidacy</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Name"
              fullWidth
              placeholder="Name of candidate"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id="dropdown-label">Election Type</InputLabel>
              <Select
                labelId="dropdown-label"
                value={electionCategory}
                onChange={handleChange}
              >
                <MenuItem value="Federal">Federal</MenuItem>
                <MenuItem value="State">State</MenuItem>
                <MenuItem value="Local">Local</MenuItem>
              </Select>
            </FormControl>
            <TextField
              autoFocus
              margin="dense"
              label="Type"
              fullWidth
              placeholder="Type of Election"
              value={type}
              onChange={(e) => setType(e.target.value)}
            />
            <TextField
              margin="dense"
              label="Reason"
              fullWidth
              placeholder="Write"
              multiline
              minRows={4}
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={handleSubmit} variant="contained">Submit</Button>
          </DialogActions>
        </Dialog> 

      </Box>
    </Box>*/
  );
}

export default Page2SubPageC;
